export const ticketCancelReasonsMessages = {
  create: 'Tạo mới lý do',
  update: 'Cập nhật lý do',
  ticketCancelReasonId: 'ID lý do',
  content: 'Nội dung lý do',
  serviceTypes: 'Loại dịch vụ',
  delete: 'Xóa lý do hủy',
  confirmDelete: 'Bạn có chắc chắn muốn xóa lý do hủy này không?'
};
